import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames';
import moment from 'moment';

import { targetUserSelector } from '../../../redux/context/selectors';
import * as historicMeasurements from '../../../redux/profiles/patientHealthboard/historic-measurements-req';
import * as vitalsActivity from '../../../redux/profiles/patientHealthboard/vitals-activity-req';
import {
  selectHistoricMeasurementsPreviousDate,
  selectVitalsActivityEntity,
} from '../../../redux/profiles/patientHealthboard/selectors';
import { VITALS_ACTIVITY_TYPE } from '../constants';
import { TYPE_CARDS } from './ActivityCard/cards';
import { ActivityCard } from './ActivityCard';
import styles from './index.styl';

const { STEPS, SATURATION, HEIGHT } = VITALS_ACTIVITY_TYPE;

export function VitalsActivity({
  formatMessage,
  isDetailsView,
  toggleDetailsView,
  contextOf,
  toggleOpenModal,
  userId,
  activeCardType,
  setActiveCardType,
  isWeightInKg,
  isHeightInMeters,
  isTemperatureInCelsius,
  isMilligramsPerDeciliter,
  mainUser,
  hideTitle,
}) {
  const vitalsActivityData = useSelector(selectVitalsActivityEntity);
  const previousDate = useSelector(selectHistoricMeasurementsPreviousDate);

  const targetUserFirstName = get(
    useSelector(targetUserSelector),
    'firstName',
    '',
  );
  const dispatch = useDispatch();
  const isSaturationType = SATURATION === activeCardType;

  const selectMeasurementEntity = type => {
    const target = vitalsActivityData.find(item => item.type === type);
    if (target) return target.measurement || {};
    return {};
  };

  const createApiRequestByType = type => {
    if (type === HEIGHT) return;
    dispatch(historicMeasurements.actions.clear());
    dispatch(
      historicMeasurements.actions.send({
        typeMeasurements: type,
        periodStartDate:
          previousDate ||
          moment(selectMeasurementEntity(type).measuredAt)
            .subtract(1, 'year')
            .format('YYYY-MM-DD'),
        userId,
      }),
    );
  };

  useEffect(() => {
    dispatch(vitalsActivity.actions.clear());
    dispatch(vitalsActivity.actions.send({ userId }));
  }, [userId]);

  const safeContext = mainUser
    ? formatMessage({ id: 'general.labels.me' })
    : contextOf;

  const safeTitle = isSaturationType ? (
    <span>
      {formatMessage({ id: 'patient.healthboard.saturation' })}
      <sub>{formatMessage({ id: 'patient.healthboard.saturation.index' })}</sub>
      )
    </span>
  ) : (
    formatMessage({ id: `patient.healthboard.${activeCardType || STEPS}` })
  );

  return (
    <div className={cn(styles.root, { [styles.rootDetails]: isDetailsView })}>
      <div className={styles.header}>
        <div className={styles.title}>
          {!hideTitle && safeTitle}
          {isDetailsView && (
            <div className={styles.contextOf}>{`${formatMessage({
              id: 'patient.healthboard.contextOf',
            })} ${safeContext}`}</div>
          )}
        </div>
      </div>
      {!isDetailsView && (
        <div className={styles.content}>
          {TYPE_CARDS.map(({ type }) => (
            <ActivityCard
              isActiveCard={activeCardType === type}
              formatMessage={formatMessage}
              detailsMode={isDetailsView}
              typeCard={type}
              mainUser={mainUser}
              data={selectMeasurementEntity(type)}
              isWeightInKg={isWeightInKg}
              isHeightInMeters={isHeightInMeters}
              isTemperatureInCelsius={isTemperatureInCelsius}
              isMilligramsPerDeciliter={isMilligramsPerDeciliter}
              targetUserFirstName={targetUserFirstName}
              handleOnClick={() => {
                toggleDetailsView(true);
                toggleOpenModal(true);
                setActiveCardType(type);
                createApiRequestByType(type);
              }}
              key={type}
            />
          ))}
        </div>
      )}
    </div>
  );
}

VitalsActivity.propTypes = {
  formatMessage: PropTypes.func,
  isDetailsView: PropTypes.bool,
  toggleDetailsView: PropTypes.func,
  contextOf: PropTypes.string,
  toggleOpenModal: PropTypes.func,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activeCardType: PropTypes.string,
  setActiveCardType: PropTypes.func,
  isWeightInKg: PropTypes.bool,
  isHeightInMeters: PropTypes.bool,
  isTemperatureInCelsius: PropTypes.bool,
  isMilligramsPerDeciliter: PropTypes.bool,
  mainUser: PropTypes.bool,
  hideTitle: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/VitalsActivity/index.jsx